import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';

import { Link, Redirect } from 'react-router-dom';
import {
    Typography,
} from '@material-ui/core';

import * as ModalStore from '../../app/store/ModalStore';
import urls from '../../app/urls';
import apiUrls from '../../youwell-common/apiUrls';
import { Image, HtmlContent } from '../../youwell-common/components';
import { InfoMessage } from '../../common/components';
import { PUBLIC_PROGRAM_RECEIVED } from '../../app/store/actions';
import { elementInfoClasses, tableListClasses } from './components/sharedStyles';

const styles = theme => ({
    ...tableListClasses(theme),
    ...elementInfoClasses(theme),
    main: {
        display: 'flex',
        flexDirection: 'column',

        [theme.breakpoints.down('xs')]: {
            paddingTop: theme.spacing(1),
        },
    },
});

class Program extends React.Component {
    render() {
        const {
            classes, translate, program, hasLoaded,
        } = this.props;


        if (!program) {
            return hasLoaded ? (<InfoMessage messageKey="noContent" />) : null;
        }

        const isSingleModule = program.modules && program.modules.length === 1;

        if (isSingleModule) {
            return (
                <Redirect
                    to={`${urls.public.program}/${program.id}/0/0`}
                />
            );
        }

        const programImage = program.frontImageId ? `${apiUrls.baseUrl}/${apiUrls.media.file}/${program.frontImageId}` : null;

        return (
            <div className={classes.root}>
                <div className={classes.main}>
                    <div className={classes.elementInfoRoot}>
                        <div className={classes.elementInfoImageContainer}>
                            {programImage && <Image src={programImage} alt="" className={classes.elementInfoImage} />}
                        </div>

                        <div className={classes.elementInfoDescriptionContainer}>
                            <div className={classes.elementInfoTitle}>
                                <Typography variant="h6">
                                    {program.name}
                                </Typography>
                            </div>

                            <HtmlContent html={program.description} className={classes.elementInfoDescription} />
                        </div>
                    </div>

                    <div className={classes.tableListRoot}>
                        <div className={classes.tableListTitleContainer}>
                            <Typography variant="subtitle1" color="inherit" className={classes.tableListTitle}>
                                {translate('modules')}
                            </Typography>
                        </div>

                        <div className={classes.tableListRows}>
                            {program.modules && program.modules.map((module, i) => (
                                <Link
                                    key={module.id}
                                    className={classnames(classes.tableListRow, classes.tableListCompleted)}
                                    to={`${urls.public.program}/${program.id}/${i}`}
                                >
                                    <div className={classes.tableListRowIndex}>
                                        <Typography variant="subtitle1" color="inherit">
                                            {i + 1}
                                        </Typography>
                                    </div>
                                    <div className={classnames(classes.tableListRowElement)}>
                                        <Typography variant="subtitle1" color="inherit" className={classes.tableListRowElementTitle}>
                                            {module.name}
                                        </Typography>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

Program.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    program: PropTypes.object,
    hasLoaded: PropTypes.bool.isRequired,
};

Program.defaultProps = {
    program: null,
};

const mapStateToProps = (state, ownProps) => ({
    translate: getTranslate(state.localize),
    program: state.publicStore.details && state.publicStore.details[ownProps.match.params.programId],
    hasLoaded: Boolean(state.publicStore.requests[`${PUBLIC_PROGRAM_RECEIVED}/${ownProps.match.params.programId}`]
    && state.publicStore.requests[`${PUBLIC_PROGRAM_RECEIVED}/${ownProps.match.params.programId}`].completed),
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(ModalStore.actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Program));
